import React from 'react';
import { BpmTable } from './BpmTable';

export const DownloadsDecisionLocationsTable = ({ locationToDownloads }) => {
    if (!locationToDownloads) {
        return null;
    }
    const rowsAndCols = getTableRowsAndCols(locationToDownloads);
    return (
        <BpmTable
            cols={rowsAndCols.cols}
            data={rowsAndCols.rows}
        />
    );
}

function getTableRowsAndCols(locationToWinLoss) {
    const result = {
        rows: [], cols: [
            {
                title: 'Country', field: 'country'
            },
            {
                title: 'Region', field: 'region'
            },
            {
                title: 'City', field: 'city'
            },
            {
                title: 'Family Downloads', field: 'downloads'
            }]
    };

    for (const value of locationToWinLoss.values()) {
        const row = {
            country: value.country,
            region: value.region,
            city: value.city,
            downloads: value.downloads
        }
        result.rows.push(row);
    }

    return result;
}